export const CARD_RADIUS_STYLES = 'rounded-[26px] md:rounded-[30px]'
